import { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import useAuth from '../hooks/useAuth';
import { useHistory } from 'react-router-dom';

export default function NewPasswordDialog({
  show,
  username,
  oldPassword,
  user,
  handleClose,
}) {
  const [newPassword, setNewPassword] = useState('');
  const [code, setCode] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const { completeNewPassword, resetPassword } = useAuth();
  const history = useHistory();
  const [error, setError] = useState('');
  const submitNewPassword = async () => {
    if (newPassword === confirmNewPassword) {
      try {
        const result = user
          ? await completeNewPassword(user, newPassword)
          : await resetPassword(username, code, newPassword);
        console.log(result);
        alert('Success! Now use new password to log in.');
        handleClose();
        history.push('/login');
      } catch (e) {
        console.log(e);
        setError(e.message);
      }
    } else {
      setError('Passwords do not match');
    }
  };
  const hasError = error && error.length > 0;

  return (
    <Modal show={show}>
      <Modal.Dialog>
        <Modal.Header closeButton>
          <Modal.Title>Create New Password</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {!user && (
            <input
              name="code"
              className={`form-control ${hasError ? 'is-invalid' : ''}`}
              required
              value={code}
              type="text"
              placeholder="enter access code from email"
              onChange={(e) => setCode(e.target.value)}
            />
          )}
          <input
            name="password"
            className={`form-control ${hasError ? 'is-invalid' : ''}`}
            required
            value={newPassword}
            type="password"
            placeholder="enter new password..."
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <input
            name="password"
            className={`form-control ${hasError ? 'is-invalid' : ''}`}
            required
            value={confirmNewPassword}
            type="password"
            placeholder="confirm password..."
            onChange={(e) => setConfirmNewPassword(e.target.value)}
          />
          {hasError && <div className="text-danger">{error}</div>}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={submitNewPassword}>
            Submit
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal.Dialog>
    </Modal>
  );
}
